<template>
  
  <v-container fluid class="pa-0" style="height:100%;" :style="'background-image:url(\'/img/sfondo.jpg\'); background-repeat:no-repeat; background-position:right top; background-size: cover;'">
    
    <div class="loginmenu" style="height:10%; margin-bottom:0px !important;">
      <div class="menu-header d-flex align-center justify-space-between">
      <div class="menu-logo">
        <a href="https://simulatoreclickday.it/"><img src="/img/logo-500x164.png" alt="Logo"></a>
      </div>
      <div class="menu-nav">
        <ul class="menu-list d-flex">
          <li><a class="sito" href="https://simulatoreclickday.it/"><span id="pulsante-sito">VAI AL SITO</span></a></li>
          <li><a class="menu-item" href="https://simulatoreclickday.it/#caratteristiche">CARATTERISTICHE</a></li>
          <li><a class="menu-item" href="https://simulatoreclickday.it/acquista/">ACQUISTA</a></li>
          <li><a class="menu-item" href="https://simulatoreclickday.it/contatti/">CONTATTI</a></li>
        </ul>
      </div>
      </div>
    </div>
    
    <!-- style="height:100%;" -->
    <div class="_loginpage d-flex" style="height:90%">
      <!-- xs12 sm10 md8 lg5 xl4 -->
      <div class="_left_column d-flex flex-column justify-space-around">
        <div style="text-align:center" class="_logo">
          <img src="/img/logo-500x164.png" style="max-width:55%; margin: auto; padding-top: 2rem" />
        </div>

        <v-progress-linear v-if="isLoading" class="mt-0 pt-0" :indeterminate="true" :color="scdColor"></v-progress-linear>

        <v-alert v-if="alertType" :type="alertType" :value="true" class="mt-0">
          <span v-html="message"></span>
        </v-alert>

        <div v-if="mostraMessaggioCredenzialiInviate" :style="`color:${scdOrange}; font-size:16px; font-weight:500;`" class="_form">
          Se la tua email è stata trovata ti manderemo la nuova password tramite posta elettronica. Se non vedi l'email controlla anche in Spam o nelle cartelle Aggiornamenti e Promozioni.
        </div>

        <v-form v-if="mostraLogin" ref="login" @submit.prevent="doLogin()" class="_form">
          <div class="_titolo text-center mb-5" style="color:#767576">
            Accedi al <span>Simulatore</span>
          </div>

          <v-text-field
            outlined
            rounded
            single-line
            prepend-inner-icon="person"
            background-color="white"
            name="username"
            v-model="username"
            type="text"
            :color="scdColor"
            class="mb-5"
            hide-details
            :rules="[vincoli.required]"
          >
            <template v-slot:label>
              <span style="line-height:24px; color:#767576">Nome Utente</span>
            </template>
          </v-text-field>

          <v-text-field
            outlined
            rounded
            single-line
            :color="scdColor"
            prepend-inner-icon="lock"
            background-color="white"
            name="password"
            v-model="password"
            id="password"
            :type="value ? 'password' : 'text'"
            :append-icon="value ? 'visibility' : 'visibility_off'"
            @click:append="() => (value = !value)"
            hide-details
            class="mb-1"
            :rules="[vincoli.required]"
          >
            <template v-slot:label>
              <span style="line-height:24px; color:#767576">Password</span>
            </template>
          </v-text-field>

          <span @click="toggleLoginResetPassword" v-if="mostraLogin" :style="`color:${scdColor}; cursor:pointer; font-size:14px; margin-left:27px;`">Ho dimenticato la password</span>

          <div class="mt-2 px-0 mx-0 d-flex justify-center">
            <v-btn rounded depressed x-large
                  class="_button px-16 mt-3" type="submit">Accedi</v-btn>
          </div>
        </v-form>

        <v-form v-else-if="mostraRecuperoPassword" ref="recuperoPassword" class="_form">
          <div class="_titolo text-center mb-5" style="color:#767576">
            Inserisci il tuo indirizzo email
          </div>

          <v-text-field
            outlined
            rounded
            single-line
            prepend-inner-icon="email"
            background-color="white"
            name="email"
            v-model="email"
            type="text"
            :color="scdColor"
            hide-details
            class="mb-1"
            :rules="[vincoli.required, vincoli.email]"
          >
            <template v-slot:label>
              <span style="line-height:24px; color:#767576">Indirizzo email</span>
            </template>
          </v-text-field>

          <span @click="toggleLoginResetPassword" v-if="mostraRecuperoPassword" :style="`color:${scdColor}; cursor:pointer; font-size:14px; margin-left:27px;`">Torna alla pagina di accesso</span>

          <div class="mt-2 px-0 mx-0" justify="center">
            <v-btn rounded depressed x-large
                  class="_button px-16 mt-3"
                  @click="recuperaPassword()">Invia credenziali</v-btn>
          </div>
        </v-form>

        <!-- <div @click="toggleLoginResetPassword">
          <span v-if="mostraLogin">Ho dimenticato la password</span>
          <span @click="toggleLoginResetPassword" v-if="mostraRecuperoPassword">Torna alla pagina di accesso</span>
        </div> -->

        <div class="mt-2 mx-1 d-flex align-center flex-column">
          <div
	          class="font-weight-regular"
	          :style="`font-size:14px; color:${scdColor};`"
          >
	          Se non possiedi ancora un account su <span class="font-weight-bold">Simulatore Click Day®</span>,<br>
	          clicca qui sotto per andare sul sito e scoprirlo!
          </div>
	        
	        <v-btn
		        class="mt-3"
		        :color="scdColor"
		        rounded
		        href="https://simulatoreclickday.it/"
		        target="_blank"
	        >
		        SCOPRI IL SIMULATORE
	        </v-btn>
        </div>
	      
	      <div class="_version d-flex justify-center">
          <span :style="`color:${scdColor}; font-weight:400`" class="caption mr-2">Versione: 5.17.0</span>
        </div>
      </div>

      <div class="_right_column d-flex flex-column justify-center">
        <h1 style="margin-bottom:30px;">Il <span>Simulatore Click Day®</span> è il software numero 1 per allenarsi a vincere il click day del <strong>bando ISI INAIL</strong>.</h1>
        <!-- <p style="margin-bottom:50px;">Grazie alle simulazioni, potrai allenare i tuoi riflessi e la coordinazione mano-occhio: diventerai molto più veloce e sarai preparato per affrontare e vincere il Click Day.</p>
        <p>Le simulazioni di Simulatore Click Day® sono compatibili con:
          <ul>
              <li>Bando isi Inail</li>
              <li>Bando Inail Agricoltura</li>
              <li>Voucher 112 POR</li>
              <li>Bando Imprenditoria Femminile</li>
          </ul>
          e molti altri...
        </p> -->
        <p style="margin-bottom:20px;">Grazie alle simulazioni super realistiche, potrai allenare i riflessi del tuo team e la coordinazione mano-occhio diventando molto più veloce. Sarai preparato per affrontare e vincere il Click Day.</p>
        <p style="margin-bottom:20px;">Le simulazioni di Simulatore Click Day® sono compatibili con tutti i Bandi ISI INAIL passati e futuri.</p>
      
      </div>
    </div>
  </v-container>
</template>

<script>
import mixin from '../mixins';
export default {
  data: () => {
    return {
      // validLogin: true,
      username: "",
      password: "",
      value: String,

      alertType: null,
      message: null,

      isLoading: false,

      mostraLogin: true,
      mostraRecuperoPassword: false,
      mostraMessaggioCredenzialiInviate: false,

      // validRecuperoPassword: true,
      email: "",
    };
  },
  created: function(){
  },
  methods: {
    doLogin: function() {
      this.alertType = null;
      this.message = null;
      this.mostraMessaggioCredenzialiInviate = false;

      if(!this.$refs.login.validate()){
        return;
      }

      this.isLoading = true;

      axios
        .post("/login", {
          username: this.username,
          password: this.password
        })
          .then(response => {
            if (response.data.alertType == "success") window.location.href = "/home";
            else {
              this.alertType = response.data.alertType;
              this.message = response.data.message;
            }
          })
          .catch(err => {
            this.alertType = "error";
            this.message = "Autenticazione fallita";
            
          })
          .finally(() => {
            this.isLoading = false;
          });
    },
    toggleLoginResetPassword() {
      this.mostraLogin = !this.mostraLogin;
      this.mostraRecuperoPassword = !this.mostraRecuperoPassword;

      if (this.mostraMessaggioCredenzialiInviate == true) {
        this.mostraMessaggioCredenzialiInviate = false;
      }
    },
    recuperaPassword() {
      this.alertType = null;
      this.message = null;
      this.mostraMessaggioCredenzialiInviate = false;

      if(!this.$refs.recuperoPassword.validate()){
        return;
      }

      axios.post('/reset_password', {
        email: this.email
      })
      .then(response => {
        if (response.data.hasError) {
          this.alertType = 'error';
          this.message = response.data.message;
        } else {
          this.toggleLoginResetPassword();
          this.mostraMessaggioCredenzialiInviate = true;
        }
      })
      .catch(err => {
        this.alertType = "error";
        this.message = "Recupero credenziali fallito";
        
      })
      .finally(() => {
        this.isLoading = false;
      });
    }
  }
};
</script>

<style scoped lang="scss">
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;600&display=swap');

  ._loginpage {
    font-family: 'Montserrat', sans-serif !important;
    font-weight: 400;
    line-height:1.5;
    @media screen and (max-width: 960px) {
      flex-direction: column-reverse;
    }
  }

  ul {
    font-weight: 600;
  }

  h1, ._titolo {
    font-weight: 400;
    font-size: 28px;
    line-height:1.2;
    span {
      font-weight: 600;
    }
  }

  p {
    font-size: 18px;
  }

  ._left_column {
    background-color:#eeeeee;
    padding: 20px 100px;
    width:55%;
    @media screen and (max-width: 960px) {
      padding: 30px 30px;
      width:100%;
    }
  }

  ::v-deep ._form {
    padding: 0 30px;
    @media screen and (max-width: 960px) {
      padding: 0 0;
    }
  }

  ._right_column {
    color:#f4f4f5;
    padding:20px 80px;
    width:45%;
    @media screen and (max-width: 960px) {
      padding: 180px 30px 50px 30px;      
      width:100%;
    }
  }

  ::v-deep .v-text-field .v-input__prepend-inner {
    padding-right: 25px !important;
  }

  ::v-deep {
    ._button {
      background-color:rgba(0, 0, 0, 0) !important; 
      color:#6D94CD;
      border: 2px solid #6D94CD;
      font-weight: 600;
      @media screen and (max-width: 960px) {
        margin-bottom: 50px;
      }
    }
    ._button:hover {
      color: #f4f4f5;
      background-color: #6D94CD !important;
    }
  }

  @media screen and (max-width: 960px) {
    ._version {
      margin-top: 50px;
    }
    ._logo {
      margin-bottom: 30px;
    }
  }
  


  .menu-header {
  background-color: white;
  height: 100%; /* Occupare tutta l'altezza del contenitore */
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 5%; /* Ridurre margini orizzontali */
  box-sizing: border-box; /* Considera padding nell'altezza totale */

  .menu-logo img {
    max-height: 50px;
  }

  .menu-nav {
    height: 100%; /* Assicura che il menu-nav occupi tutta l'altezza */
    
    .menu-list {
      list-style: none;
      margin: 0;
      padding: 0;
      display: flex;
      gap: 0px;
      height: 100%; /* Forza i figli a ereditare questa altezza */

      li {
        display: flex; /* Per estendere l'altezza dei figli */
        align-items: center; /* Centrare verticalmente */
        height: 100%; /* Forza l'altezza dei link al 100% */

        a.menu-item {
          text-decoration: none;
          color: #333;
          font-weight: 600;
          font-size: 14px;
          letter-spacing: 1px;
          transition: color 0.3s ease, background-color 0.3s ease;
          display: flex; /* Estende l'elemento in altezza */
          align-items: center; /* Centrare il contenuto verticalmente */
          justify-content: center; /* Centrare il contenuto orizzontalmente */
          height: 100%; /* Riempie l'altezza del genitore */
          padding: 0 25px; /* Spaziatura orizzontale */

          &:hover {
            background-color: #6D94CD;
            color: white;
          }
        }

        

        }

      }
      a.sito {
        text-decoration: none !important;
      }
      a.sito:hover { 
        background-color: none !important;
      }
      #pulsante-sito {
        color:white !important;
        margin:1rem; 
        background-color:#F08339; 
        padding: 0.85rem 2.5rem;
      }
      #pulsante-sito:hover {
        background-color: #6D94CD;
      }
      

  }
}


.loginmenu {
  height: 10%;
  margin: 0 !important; 
  padding: 0 !important; 
  box-sizing: border-box;
}



@media (max-width:916px) { 
    .menu-item {
      display: none !important;
    }

    #pulsante-sito {
        color:white !important;
        margin:0.5rem !important;
        background-color:#F08339; 
        padding: 0.5rem 1rem !important;
        font-size:11px !important;
      }


   .loginmenu {
    height: 5% !important;
  }

  ._loginpage {
    height: 95% !important;
  }



 }





</style>